import { useDataflowStore } from "@/stores/dataflow";
import { PROCESSED_LAYER_PREFIX } from "@/utils/constants/map";
import type { MapLayerState, MapLayerActions } from "@/types/stores/map";

export function createDataLayerActions(
  set: any,
  get: () => MapLayerState & MapLayerActions
) {
  return {
    setDataLayerVisibility: (layerId: string, isVisible: boolean) => {
      set(
        (state: MapLayerState) => ({
          dataLayers: {
            ...state.dataLayers,
            [layerId]: isVisible,
          },
        }),
        false,
        "map/setDataLayerVisibility"
      );

      if (layerId === "my-data-input") {
        const activeDataflowId = useDataflowStore.getState().activeDataflowId;
        if (activeDataflowId) {
          const geoJSONLayerId = `${PROCESSED_LAYER_PREFIX}${activeDataflowId}`;
          const geoJSONLayer = get().geoJSONLayers[geoJSONLayerId];
          if (geoJSONLayer) {
            get().updateGeoJSONLayerVisibility(geoJSONLayerId, isVisible);
          }
        }
      }
    },

    toggleDataLayer: (layerId: string) => {
      const state = get();
      const newValue = !(state.dataLayers[layerId] ?? true);
      get().setDataLayerVisibility(layerId, newValue);

      if (layerId === "my-data-input") {
        const activeDataflowId = useDataflowStore.getState().activeDataflowId;
        if (activeDataflowId) {
          const geoJSONLayerId = `${PROCESSED_LAYER_PREFIX}${activeDataflowId}`;
          const geoJSONLayer = state.geoJSONLayers[geoJSONLayerId];
          if (geoJSONLayer) {
            get().updateGeoJSONLayerVisibility(geoJSONLayerId, newValue);
          }
        }
      }
    },
  };
}

